import { persist } from "zustand/middleware";
import { create } from "zustand";
import {
  Permissions,
  TCriterioData,
  TRole,
  TUser,
} from "../modules/users/models";
import CryptoJS from "crypto-js";

interface PermissionStore {
  permissions: Permissions[];
  setPermissions: (permissions: Permissions[]) => void;
  clearPermissions: () => void;
  role: TRole | string;
  setRole: (role: TRole | undefined) => void;
  scenarioId: TCriterioData[];
  setScenarioId: (scenarioId: TCriterioData[]) => void;
  accountId: number;
  setAccountId: (accountId: number) => void;
  storageUser: TUser | undefined;
  setStorageUser: (storageUser: TUser) => void;
  clearAll: () => void;
}

const SECRET_KEY = import.meta.env.VITE_APP_HASH_KEY;

const encrypt = (data: unknown) =>
  CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
const decrypt = (data: string) =>
  JSON.parse(
    CryptoJS.AES.decrypt(data, SECRET_KEY).toString(CryptoJS.enc.Utf8)
  );

const usePermissionStore = create<PermissionStore>()(
  persist(
    (set) => ({
      permissions: [],
      setPermissions: (permissions) => set({ permissions }),
      clearPermissions: () => set({ permissions: [] }),
      role: "",
      setRole: (role) => set({ role }),
      scenarioId: [{ accountId: 0, scenarioId: 0 }],
      setScenarioId: (scenarioId) => set({ scenarioId }),
      accountId: 0,
      setAccountId: (accountId) => set({ accountId }),
      storageUser: undefined,
      setStorageUser: (storageUser) => set({ storageUser }),
      clearAll: () =>
        set({
          permissions: [],
          role: "",
          scenarioId: [{ accountId: 0, scenarioId: 0 }],
          accountId: 0,
          storageUser: undefined,
        }),
    }),
    {
      name: "permission-storage",
      storage: {
        getItem: (key) => decrypt(localStorage.getItem(key) || ""),
        setItem: (key, value) => localStorage.setItem(key, encrypt(value)),
        removeItem: (key) => localStorage.removeItem(key),
      },
    }
  )
);

export default usePermissionStore;
